import React, { useState, useEffect } from 'react';
import { FiLink, FiCode, FiCheck } from 'react-icons/fi';
import { 
  FaInstagram as FaInstagramIcon, 
  FaXTwitter as FaXTwitterIcon, 
  FaFacebookF as FaFacebookFIcon, 
  FaLinkedinIn as FaLinkedinInIcon 
} from 'react-icons/fa6';
import ModalBasic from '../components/ModalBasic';

const ButtonContent = ({ text, isCopied }) => {
  return (
    <span className="inline-flex items-center justify-center gap-2">
      {text}
    </span>
  );
};

const Embed = ({ campaignId }) => {
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleCopy = async (href, index) => {
    try {
      await navigator.clipboard.writeText(href);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 3000);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleModalCopy = async (href) => {
    try {
      await navigator.clipboard.writeText(href);
      setSelectedPlatform(prev => ({ ...prev, copied: true }));
      
      setTimeout(() => {
        setSelectedPlatform(prev => prev ? { ...prev, copied: false } : null);
      }, 3000);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleModalOpen = (isOpen) => {
    setModalOpen(isOpen);
    if (!isOpen) {
      setSelectedPlatform(prev => prev ? { ...prev, copied: false } : null);
    }
  };

  const renderModalContent = () => {
    if (!selectedPlatform) return null;

    if (selectedPlatform.name === 'Embed') {
      return (
        <div className="p-6" style={{
          background: 'rgba(52, 73, 94, 0.3)',
          fontFamily: '"Share Tech Mono", monospace'
        }}>
          <div className="space-y-6">
            <div className="space-y-4">
              <p className="text-sm font-bold tracking-wide" style={{
                color: '#F1C40F',
                textShadow: '1px 1px 0px #E67E22',
                fontFamily: '"Share Tech Mono", monospace'
              }}>💻 ADD THIS CODE TO YOUR WEBSITE:</p>
              <div className="p-4 rounded-lg border-2" style={{
                background: 'rgba(44, 62, 80, 0.8)',
                borderColor: 'rgba(241, 196, 15, 0.6)',
                boxShadow: '0 0 10px rgba(241, 196, 15, 0.2)'
              }}>
                <pre className="text-sm whitespace-pre-wrap break-all" style={{
                  color: '#ECF0F1',
                  fontFamily: '"Share Tech Mono", monospace',
                  lineHeight: '1.4'
                }}>
                  {`<div style="position: relative; padding-bottom: 56.25%; height: 0;">
  <iframe 
    src="${window.location.origin}/play/${campaignId}"
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
    allow="web-share"
  ></iframe>
</div>`}
                </pre>
              </div>
              <button 
                onClick={() => handleModalCopy(`<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="${window.location.origin}/play/${campaignId}" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" allow="web-share"></iframe></div>`)}
                className="w-full text-center mt-4 inline-flex items-center justify-center px-4 py-3 text-sm font-bold tracking-wider rounded-lg transition-all duration-200"
                style={{
                  background: 'linear-gradient(135deg, #3498DB, #2980B9)',
                  color: '#FFFFFF',
                  border: '2px solid #F1C40F',
                  textShadow: '1px 1px 0px #1F4E79',
                  fontFamily: '"Share Tech Mono", monospace',
                  boxShadow: '0 0 15px rgba(52, 152, 219, 0.4)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #2980B9, #3498DB)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #3498DB, #2980B9)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <ButtonContent 
                  text={selectedPlatform.copied ? 'CODE COPIED!' : 'COPY CODE'} 
                  isCopied={selectedPlatform.copied} 
                />
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="p-6" style={{
        background: 'rgba(52, 73, 94, 0.3)',
        fontFamily: '"Share Tech Mono", monospace'
      }}>
        <div className="space-y-6">
          <div className="space-y-4">
            <p className="text-sm font-bold tracking-wide" style={{
              color: '#F1C40F',
              textShadow: '1px 1px 0px #E67E22',
              fontFamily: '"Share Tech Mono", monospace'
            }}>
              🚀 SHARE YOUR GAME ON {selectedPlatform.name.toUpperCase()}:
            </p>
            <ol className="space-y-3">
              {selectedPlatform.steps.map((step, index) => (
                <li key={index} className="flex items-start">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full mr-3 text-sm font-bold" style={{
                    background: 'linear-gradient(135deg, #F1C40F, #E67E22)',
                    color: '#2C3E50',
                    border: '1px solid rgba(241, 196, 15, 0.6)',
                    fontFamily: '"Share Tech Mono", monospace',
                    textShadow: '1px 1px 0px #F39C12'
                  }}>
                    {index + 1}
                  </span>
                  <span className="text-sm font-medium leading-relaxed" style={{
                    color: '#ECF0F1',
                    fontFamily: '"Share Tech Mono", monospace'
                  }}>{step}</span>
                </li>
              ))}
            </ol>
            <button 
              onClick={() => handleModalCopy(`${window.location.origin}/play/${campaignId}`)}
              className="w-full text-center mt-4 inline-flex items-center justify-center px-4 py-3 text-sm font-bold tracking-wider rounded-lg transition-all duration-200"
              style={{
                background: 'linear-gradient(135deg, #3498DB, #2980B9)',
                color: '#FFFFFF',
                border: '2px solid #F1C40F',
                textShadow: '1px 1px 0px #1F4E79',
                fontFamily: '"Share Tech Mono", monospace',
                boxShadow: '0 0 15px rgba(52, 152, 219, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'linear-gradient(135deg, #2980B9, #3498DB)';
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'linear-gradient(135deg, #3498DB, #2980B9)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <ButtonContent 
                text={selectedPlatform.copied ? '✅ LINK COPIED!' : 'COPY LINK'} 
                isCopied={selectedPlatform.copied} 
              />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const platforms = [
    {
      name: 'Copy Link',
      icon: <FiLink className="w-6 h-6" />,
      href: `${window.location.origin}/play/${campaignId}`,
      steps: [],
    },
    {
      name: 'Embed',
      icon: <FiCode className="w-6 h-6" />,
      href: `<iframe src="${window.location.origin}/play/${campaignId}" allow="web-share"></iframe>`,
      steps: [],
    },
    {
      name: 'Instagram',
      icon: <FaInstagramIcon className="w-6 h-6" />,
      href: `${window.location.origin}/play/${campaignId}`,
      steps: [
        "Copy your game link",
        "Add to a story using the link functionality",
      ],
    },
    {
      name: 'X',
      icon: <FaXTwitterIcon className="w-6 h-6" />,
      href: `${window.location.origin}/play/${campaignId}`,
      steps: [
        "Copy your game link",
        "Create a new post",
        "Paste the link - it will automatically create a preview card"
      ],
    },
    {
      name: 'Facebook',
      icon: <FaFacebookFIcon className="w-6 h-6" />,
      href: `${window.location.origin}/play/${campaignId}`,
      steps: [
        "Copy your game link",
        "Create a new post",
        "Paste the link - it will automatically create a preview card",
        "Add your message and post"
      ],
    },
    {
      name: 'LinkedIn',
      icon: <FaLinkedinInIcon className="w-6 h-6" />,
      href: `${window.location.origin}/play/${campaignId}`,
      steps: [
        "Copy your game link",
        "Create a new post",
        "Paste the link - it will automatically create a preview card",
        "Add your message and post"
      ],
    }
  ];

  return (
    <>
      <div className="mt-6 rounded-xl px-5 pt-3 pb-5" style={{
        background: 'linear-gradient(135deg, #2C3E50, #34495E)',
        border: '2px solid rgba(241, 196, 15, 0.4)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
      }}>
        <div className="text-xs uppercase font-bold tracking-wide mb-4" style={{
          color: '#F1C40F',
          textShadow: '0 0 8px rgba(241, 196, 15, 0.5)',
          fontFamily: '"Share Tech Mono", monospace'
        }}>
          🚀 SHARE & EMBED
        </div>
        
        <div className="grid grid-cols-2 gap-3">
          {platforms.map((platform, index) => (
            <button
              key={platform.name}
              onClick={() => {
                if (platform.name === 'Copy Link') {
                  handleCopy(platform.href, index);
                } else if (platform.name === 'Embed') {
                  setSelectedPlatform(platform);
                  setTimeout(() => {
                    handleModalOpen(true);
                  }, 200);
                } else {
                  setSelectedPlatform(platform);
                  setTimeout(() => {
                    handleModalOpen(true);
                  }, 200);
                }
              }}
              className="flex flex-col items-center justify-center p-3 rounded-lg transition-all duration-200 font-bold text-xs tracking-wide"
              style={{
                background: 'rgba(52, 73, 94, 0.6)',
                color: '#ECF0F1',
                border: '1px solid rgba(241, 196, 15, 0.4)',
                fontFamily: '"Share Tech Mono", monospace'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                e.target.style.color = '#F1C40F';
                e.target.style.border = '1px solid rgba(241, 196, 15, 0.6)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(52, 73, 94, 0.6)';
                e.target.style.color = '#ECF0F1';
                e.target.style.border = '1px solid rgba(241, 196, 15, 0.4)';
              }}
            >
              <div className="text-2xl mb-1">{platform.icon}</div>
              {copiedIndex === index ? (
                <span className="text-green-400 font-bold">✅ COPIED!</span>
              ) : (
                <span>{platform.name.toUpperCase()}</span>
              )}
            </button>
          ))}
        </div>
      </div>

      <ModalBasic
        id="platform-modal"
        title={`🚀 ${selectedPlatform?.name?.toUpperCase() || ''}`}
        modalOpen={modalOpen}
        setModalOpen={handleModalOpen}
      >
        {renderModalContent()}
      </ModalBasic>

      {/* Social Media Cache Info */}
      <div className="mt-4 rounded-xl px-4 py-3" style={{
        background: 'rgba(52, 73, 94, 0.2)',
        border: '1px solid rgba(241, 196, 15, 0.2)',
      }}>
        <details className="cursor-pointer">
          <summary className="text-xs font-bold tracking-wide select-none" style={{
            color: '#F1C40F',
            fontFamily: '"Share Tech Mono", monospace'
          }}>
            💡 SOCIAL MEDIA TROUBLESHOOTING
          </summary>
          <div className="mt-3 space-y-2 text-xs font-bold" style={{
            color: '#ECF0F1',
            fontFamily: '"Share Tech Mono", monospace'
          }}>
            <p>
              <strong style={{color: '#F1C40F'}}>Old images still showing?</strong> Social media platforms cache preview images. Try these tools to refresh:
            </p>
            <div className="grid grid-cols-1 gap-2 mt-2">
              <a
                href={`https://developers.facebook.com/tools/debug/?q=${window.location.origin}/play/${campaignId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-2 rounded text-center transition-all duration-200"
                style={{
                  background: 'rgba(59, 89, 152, 0.8)',
                  color: '#FFFFFF',
                  border: '1px solid rgba(241, 196, 15, 0.3)'
                }}
              >
                🔧 FACEBOOK DEBUGGER
              </a>
              <a
                href={`https://cards-dev.twitter.com/validator`}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-2 rounded text-center transition-all duration-200"
                style={{
                  background: 'rgba(29, 161, 242, 0.8)',
                  color: '#FFFFFF',
                  border: '1px solid rgba(241, 196, 15, 0.3)'
                }}
              >
                🔧 TWITTER VALIDATOR
              </a>
              <a
                href={`https://www.linkedin.com/post-inspector/inspect/${encodeURIComponent(window.location.origin + '/play/' + campaignId)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-2 rounded text-center transition-all duration-200"
                style={{
                  background: 'rgba(0, 119, 181, 0.8)',
                  color: '#FFFFFF',
                  border: '1px solid rgba(241, 196, 15, 0.3)'
                }}
              >
                🔧 LINKEDIN INSPECTOR
              </a>
            </div>
            <p className="text-xs mt-2" style={{color: '#95A5A6'}}>
              These tools will force the platforms to refresh their cached preview data for your game.
            </p>
          </div>
        </details>
      </div>
    </>
  );
};

export default Embed;
